import type { SessionGrant } from "../../types/session";

/**
 * 세션 보관 — 메모리 + sessionStorage(탭 한정). 쿠키·localStorage 는 쓰지 않는다(ADR-B06 쿠키리스,
 * SR-AUTH-01 "표시 이름은 세션 저장소에만"). 탭을 닫으면 사라진다.
 */
export interface SessionStore {
  load(): SessionGrant | null;
  save(s: SessionGrant): void;
  clear(): void;
}

export const STORAGE_KEY = "pf.session.v1";

export function createSessionStore(storage: Storage | null = safeSessionStorage()): SessionStore {
  let memory: SessionGrant | null = null;
  return {
    load() {
      if (memory) return memory;
      if (!storage) return null;
      try {
        const raw = storage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const v = JSON.parse(raw) as SessionGrant;
        if (typeof v?.token !== "string" || typeof v?.expiresAt !== "string") return null;
        memory = v;
        return v;
      } catch {
        return null;
      }
    },
    save(s) {
      memory = s;
      try {
        storage?.setItem(STORAGE_KEY, JSON.stringify(s));
      } catch {
        // 사파리 사생활 보호 모드 등 — 메모리만으로 계속한다.
      }
    },
    clear() {
      memory = null;
      try {
        storage?.removeItem(STORAGE_KEY);
      } catch {
        /* 무시 */
      }
    },
  };
}

function safeSessionStorage(): Storage | null {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
}
